import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/manhattan")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      { title: "Schedule Your FREE Hair Transplant Consultation in Manhattan, NY" },
      {
        name: "description",
        content:
          "Schedule your free consultation with RESTORE in Manhattan New York! You can do it in-person or virtually. Our client advisors will answer your questions!",
      },
      {
        property: "og:title",
        content: "Schedule Your FREE Hair Transplant Consultation in Manhattan, NY",
      },
      {
        property: "og:description",
        content:
          "Book a free in-person or virtual hair restoration consultation with RESTORE in Manhattan, New York.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/manhattan/",
      },
    ],
  }),
  component: ScheduleManhattanPage,
});

function ScheduleManhattanPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Consultation
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation in Manhattan
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&owner=24213130&appointmentType=49646097" />
        </div>
      </main>
      <Footer />
    </div>
  );
}